
/* production */
export const url = `https%3A%2F%2Fiteach-admin.nknu.edu.tw%2Fline_login`
export const client_id = `2005666429`
export const token_url = `https%3A%2F%2Fapi-iteach.nknu.edu.tw%2Fqrcode%2Fnotify_bind`
export const token_client_id = `w98MOQZaLDVidr9e6FEHgP`
/* production */

/* test */
// export const url = `https%3A%2F%2Fwww.orange-technic.com%3A7444%2Fline_login`
// export const client_id = `2002932828`
// export const token_url = `https%3A%2F%2Fwww.orange-technic.com%3A7443%2Fqrcode%2Fnotify_bind`
// export const token_client_id = `gJ5FlzywDgVRHR9M502M5A`
/* test */

/* develop */
// export const url = `http%3A%2F%2Flocalhost%3A3000%2Fline_login`
// export const client_id = `2000738382`
// export const token_url = `http%3A%2F%2Flocalhost%3A8082%2Fqrcode%2Fnotify_bind`
// export const token_client_id = `GZcZQFjJvSnOEhQAPhvzVi`
/* develop */